export const INIT_ACTIVITIES = "InitActivities";
export const APPLICATION_ACTIVITIES = "AppActivities";
export const PROVIDER = "ActivityProvider";
export const ACTIVITY_STATES_KEY = "ActivityResources";
export const ATTRIBUTE_ACTIVITY = "data-activity";
export const SCORE_DATA = "scoreData";
export const ACTIVITY_CONTAINER = "activityContainer";
export const TOOLTIP_CONTAINER = "tooltipContainer";
export const COLOR_PICKER_CONTAINER = "colorPickerContainer";
export const FOCUSABLE_ELEMENTS = [
  ".focusable",
  "a[href]",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[contenteditable]",
  '[tabindex]:not([tabindex^="-"])'
];
